import { useEffect } from 'react'

import { api, usePrefetch } from '@/api'
import { useAppDispatch } from '@/utils/useAppDispatch'
import { useAppSelector } from '@/utils/useAppSelector'

import { initializeCheckoutState } from '../checkout/checkoutSlice'
import { useIsLoggedInV2 } from '../common/useIsLoggedIn'

export const useAuth = () => {
  const { isHydrated, tokenDefined, isLoggedIn } = useIsLoggedInV2()
  const dispatch = useAppDispatch()
  const market = useAppSelector((state) => state.config.market)
  const lang = useAppSelector((state) => state.config.locale)
  const fetchProfile = usePrefetch('fetchProfile')

  useEffect(() => {
    if (!isHydrated || !tokenDefined) {
      return
    }
    dispatch(api.util.invalidateTags([{ type: 'User' }]))
    fetchProfile(lang)
  }, [fetchProfile, dispatch, isHydrated, tokenDefined, lang])

  useEffect(() => {
    if (!isLoggedIn || !market) {
      return
    }
    dispatch(initializeCheckoutState)
  }, [dispatch, isLoggedIn, market])
}
